
import {Component, Prop, Vue} from "vue-property-decorator";
import {IApp} from "@/interfaces/app.interface";
import moment from "moment";

  @Component({})
  export default class AppDatePicker extends Vue {
    @Prop() value: string;
    @Prop() dateStart!: string;
    @Prop() dateEnd!: string;
    @Prop() propName: string;
    @Prop() placeholder!: string;
    @Prop() popperClass!: string;
    @Prop({ default: 'start' }) direction: 'start' | 'end';

    dateFormats = IApp.DateFormats;
    intervalId = null;

    onChange(value) {
      this.$emit('input', value);
      this.setEndValueAfterChangeStart(value);
    }

    setEndValueAfterChangeStart(value: string) {
      if (this.direction === 'start' && !!value) {
        let today = moment().format(IApp.DateFormats.PrintedDate);
        let startDate = moment(value, IApp.DateFormats.PrintedDate).format(IApp.DateFormats.PrintedDate);
        let startMonth = moment(value, IApp.DateFormats.PrintedDate).startOf('month').format(IApp.DateFormats.PrintedDate);
        if (startDate === startMonth && this.dateEnd && this.dateEnd !== today) {
          let endValue = moment(value, IApp.DateFormats.PrintedDate)
            .endOf('month')
            .format(IApp.DateFormats.PrintedDate);
          this.$emit('shortcutAction', { end: endValue });
        }
      }
    }

    pickerOptions(direction: string) {
      let options = {
        ...IApp.DatePickerOptions.Simple,
        shortcuts: this.pickerShortCuts(direction),
        // disabledDate: (value) => this.disableDateInPicker(value, direction),
      };

      return options;
    }

    pickerShortCuts(direction: string) {
      const dateToday = moment().format(IApp.DateFormats.PrintedDate);
      const dateAction = (count, metric) => {
        return {
          beg: moment().add(count, `${metric}s`).startOf(metric).format(IApp.DateFormats.PrintedDate),
          end: moment().add(count, `${metric}s`).endOf(metric).format(IApp.DateFormats.PrintedDate),
        };
      };

      const nameCodes = {
        today: { beg: dateToday, end: dateToday },
        tomorrow: dateAction(-1, 'day'),
        currentWeek: dateAction(0, 'week'),
        lastWeek: dateAction(-1, 'week'),
        currentMonth: dateAction(0, 'month'),
        lastMonth: dateAction(-1, 'month'),
        currentYear: dateAction(0, 'year'),
        lastYear: dateAction(-1, 'year'),
      };

      const pickerShortCutActions = (picker, name) => {
        picker.$emit('pick');
        this.$emit('shortcutAction', {
          start: nameCodes[name].beg,
          end: nameCodes[name].end,
        });
      };

      const shortCuts = [
        { text: 'Сегодня', onClick: (picker) => pickerShortCutActions(picker, 'today') },
        { text: 'Вчера', onClick: (picker) => pickerShortCutActions(picker, 'tomorrow') },
        { text: 'Текущая неделя', onClick: (picker) => pickerShortCutActions(picker, 'currentWeek') },
        { text: 'Прошлая неделя', onClick: (picker) => pickerShortCutActions(picker, 'lastWeek') },
        { text: 'Текущий месяц', onClick: (picker) => pickerShortCutActions(picker, 'currentMonth') },
        { text: 'Прошлый месяц', onClick: (picker) => pickerShortCutActions(picker, 'lastMonth') },
        { text: 'Текущий год', onClick: (picker) => pickerShortCutActions(picker, 'currentYear') },
        { text: 'Прошлый год', onClick: (picker) => pickerShortCutActions(picker, 'lastYear') },
      ];

      if (direction === 'end') {
        shortCuts.push({
          text: 'Конец месяца',
          onClick: (picker) => {
            picker.$emit('pick');
            let startValue = this.dateStart ? this.dateStart : this.value;
            let endValue = moment(startValue, IApp.DateFormats.PrintedDate)
              .endOf('month')
              .format(IApp.DateFormats.PrintedDate);

            this.$emit('shortcutAction', { end: endValue });
          }
        });
      }

      return shortCuts;
    }

    disableDateInPicker(value, direction) {
      // let current = Number(moment(value).format('x'));
      // let today = Number(moment().startOf('day').format('x'));
      //
      // let disabled = current > today;
      // switch(direction) {
      //   case 'start':
      //     if (this.formModel.dateEnd) {
      //       let dateEnd = Number(moment(this.formModel.dateEnd, IApp.DateFormats.PrintedDate).format('x'));
      //       disabled = current > dateEnd;
      //     }
      //     break;
      //
      //   case 'end':
      //     if (this.formModel.dateBeg) {
      //       let dateBeg = Number(moment(this.formModel.dateBeg, IApp.DateFormats.PrintedDate).format('x'));
      //       disabled = current > today || current < dateBeg;
      //     }
      //     break;
      // }
      //
      // return disabled;
    }

    checkDisabledArrow() {
      //on default arrow for select next months is disabled
      //and set disabled arrow if once click on this arrow
      //start switch off disabled in interval, when focus on input start
      this.intervalId = setInterval(() => {
        let arrow: any = document.querySelector('.el-picker-panel__icon-btn.el-icon-arrow-right');
        let doubleArrow: any = document.querySelector('.el-picker-panel__icon-btn.el-icon-d-arrow-right');
        if (arrow && arrow.classList.contains('is-disabled')) {
          arrow.disabled = false;
          arrow.classList.remove('is-disabled');
        }
        if (doubleArrow && doubleArrow.classList.contains('is-disabled')) {
          doubleArrow.disabled = false;
          doubleArrow.classList.remove('is-disabled');
        }
      }, 100);
    }

    clearIntervalDisable() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
